import assetPath from '/app/xinglets/insights/entry-logged-out/src/components/salary-banner/salary-background-mobile.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')